const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
  const { title, containerized, margin } = attributes;

  return (
    <section className={`ColorCards ${margin}`}>
      <div className={`${containerized ? 'Container' : ''}`}>
        <RichText.Content
          tagName="h2"
          value={title}
          className="Typography title-5 center color-blue-dark margin-small"
        />

        <div className="ColorCards__content">
          <InnerBlocks.Content />
        </div>
      </div>
    </section>
  );
};
